module.exports = __webpack_public_path__ + "img/hebei.0e8c9ade.png";